import c from "../common";

export default {
  //Column
  Time: "Time",
  status: c.status.en,
  paid: "Paid",
  currency: "Currency",
  assistant: c.assistant.en.uppercase,
  vendorName: c.vendor.en.uppercase + " Name",
  consumer: c.consumer.en.uppercase,
  totalAmount: "Total Amount(CAD)",
  paymentGateway: "Payment Gateway",
  atStore: "Paid At Store",
  onApp: "Paid On App",
  reference: "Payment Reference",

  totalQty: "Total Quantity",
  qty: "Quantity",
  voucherName: c.voucher.en.uppercase + " Name",
  voucherId: c.voucher.en.uppercase + " ID",
  price: "Amount(CAD)",

  staffId: c.assistant.en.uppercase + " ID",
  consumerEmail: c.consumer.en.uppercase + " Email",

  download: c.download.en.uppercase,
};
